import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import '@fontsource/roboto'
import '@mdi/font/css/materialdesignicons.css'
import { StaticDataService } from './services/staticdata.service'

Vue.config.productionTip = false

export const staticDataService = new StaticDataService();

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
